import { Language, TranslatedText } from "./translated-text";

export class ComboCategory {
  id: string;
  isVisible: boolean;
  name: TranslatedText;
  products: any[];

  constructor(id: string, name: string | TranslatedText, products: any[], isVisible = true) {
    this.id = id;
    this.isVisible = isVisible;
    this.name = typeof name === "string" ? new TranslatedText(name, Language.EN_US) : name;
    this.products = products;
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
